export default "__VITE_ASSET__B39MyyV0__"